"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.advanceComponents = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _childForm = _interopRequireDefault(require("./childForm.json"));

var _fileUpload = _interopRequireDefault(require("./fileUpload.json"));

var _imgUpload = _interopRequireDefault(require("./imgUpload.json"));

var _linkForm = _interopRequireDefault(require("./linkForm.json"));

var _linkTable = _interopRequireDefault(require("./linkTable.json"));

var _editor = _interopRequireDefault(require("./editor.json"));

require("./index.less");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var advanceComponents = [].concat((0, _toConsumableArray2.default)([_childForm.default, _fileUpload.default, _imgUpload.default, _editor.default].map(function (config) {
  return _objectSpread(_objectSpread({}, config), {}, {
    property: [].concat((0, _toConsumableArray2.default)(config.property), [{
      tag: 'mh-form-item',
      name: '_notEditable',
      label: '是否可编辑',
      options: {
        valuePropName: 'checked'
      },
      children: {
        tag: 'a-checkbox',
        children: '不可编辑'
      }
    }, {
      tag: 'mh-form-item',
      name: '_valueNotEditable',
      label: '有值时不可编辑',
      options: {
        valuePropName: 'checked'
      },
      children: {
        tag: 'a-checkbox',
        children: '不可编辑'
      }
    }, {
      tag: 'mh-form-item',
      name: '_tableWidth',
      label: '表格中列宽',
      children: {
        tag: 'a-input-number'
      }
    }, {
      tag: 'mh-form-item',
      name: '_text',
      label: '展示函数',
      _langProperty: true,
      children: {
        tag: 'a-textarea'
      }
    }])
  });
})), [// jsonView,
_linkForm.default, _linkTable.default]);
exports.advanceComponents = advanceComponents;